import React from 'react';
import fileService from '../../services/fileService';
import ThreeDViewer from './ThreeDViewer';
import PDFViewer from './PDFViewer';
import DCMViewer from './DCMViewer';

const FileViewer = React.memo(({ fileId, filename }) => {
  const url = fileService.getDownloadUrl(fileId);
  const previewUrl = fileService.getPreviewUrl(fileId);
  const extension = filename?.split('.').pop().toLowerCase();

  const renderViewer = () => {
    switch (extension) {
      case 'stl':
      case 'ply':
        return <ThreeDViewer url={url} extension={extension} />;
      case 'pdf':
        return <PDFViewer url={previewUrl} />;
      case 'dcm':
        return <DCMViewer urls={[url]} />;
      default:
        return (
          <div className="viewer-overlay viewer-no-preview">
            <i className="material-icons">visibility_off</i>
            <p>Aperçu non disponible pour ce type de fichier</p>
          </div>
        );
    }
  };

  return (
    <div className="file-viewer">
      {renderViewer()}
    </div>
  );
});

export default FileViewer;
